import React, { useRef } from 'react';

// Styles & Assets
import styles from './PatientCalendarPage.module.css';

// Hooks
import { useOutletContext, useParams } from 'react-router-dom';

// Interfaces
import { Patient } from '../../interfaces/Patient';
import { useTranslation } from 'react-i18next';
import { getUser } from '../../services/Auth';
import { UserData } from '../../interfaces/UserInfo';


const PatientCalendarPage: React.FC = () => {

    // Hooks
    const { patient }: { patient: Patient } = useOutletContext();
    const { id } = useParams();
    const { i18n } = useTranslation();


    const hospitalCase = patient?.cases?.find(caso => caso.id === Number(id))?.hospital_case ?? '';

    const userEmail: UserData = getUser();

    const url = window.config.CALENDAR_URL.replace('USER_UUID', patient.pid_1 ?? '').replace('USER_EMAIL', userEmail.email).replace('HOSPITAL_CASE', hospitalCase) + `&len=${i18n.language.toLocaleUpperCase()}`;

    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    return (
        <div className={styles.container}>
            {/* <div className={styles.iframeWrapper}> */}
            <iframe
                className={styles.iframe}
                ref={iframeRef}
                src={url}
                title="Embedded Iframe"
            />
        </div>
        // </div>
    );
};

export default PatientCalendarPage;